import React from 'react';
import Logo from '../../images/simple2.png';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { db, function_, analytics } from '../../firebase';
import ReactPixel from 'react-facebook-pixel';
import { addShopInfoAction, addCategoriesProductsAction } from '../../redux/actions';
import Image from 'react-bootstrap/Image';

class Home extends React.Component {
	state = {
		categories: [],
		urlPhoto: '',
		loaded: false,
		currentPosition: 0,
		opacity: 0
	};

	async componentDidMount() {
		window.localStorage.clear();
		localStorage.removeItem("state");

		let { shopUid } = this.props;
		let { pageName } = this.props.match.params;

		pageName = pageName.toLowerCase()
	
		setTimeout(
			() =>
				this.setState({
					opacity: 1
				}),
			500
		);
		
		analytics.logEvent('goal_completion', { name: 'lever_puzzle'});

		const data = await db.collection('usersrelations').doc(pageName).get();
		shopUid = data.data().useruid;
		const paid = data.data().paid;

		const callableReturnMessage = function_.httpsCallable('showCategories');

		const userInformation = await callableReturnMessage({
			useruid: shopUid
		});

		ReactPixel.track('Info TIENDA',{'shopUid': shopUid});
		
		this.props.addCategoriesProducts(userInformation.data.categories_);
		
		const object = {
			shopUid, //shopuid
			shopColor: userInformation.data.shopColor || 'orange',
			url: userInformation.data.url,
			urlPortada: userInformation.data.urlPortada,
			whatsapp: userInformation.data.whatsapp,
			facebook: userInformation.data.facebook,
			instagram: userInformation.data.instagram,
			description: userInformation.data.description,
			shopEmail: userInformation.data.shopEmail,
			shopName: userInformation.data.shopName,
			nameStore: data.id, // 6 simpleqr.cl/huevo (huevo)
			name: userInformation.data.name, //name of the store that user puts in admin
			delivery: userInformation.data.delivery,
			deliveryInformation: userInformation.data.deliveryInformation,
			dispatchTime: userInformation.data.dispatchTime || '',
			shopDirection: userInformation.data.shopDirection || '',
			toggleWithdrawal: userInformation.data.toggleWithdrawal,
			toggleDelivery: userInformation.data.toggleDelivery,
			toggleWhatsAppMethod:  userInformation.data.toggleWhatsAppMethod,
			footerItem: {
				categories: 1,
				aboutUs: 0,
				shoppingCart: 0
				}
		};

		this.props.addShopInfo(object);

		this.setState({
			nameStore: data.id,
			loaded: true,
			paid,
			url: object.url
		});
	}

	render() {
		if(this.state.paid === false){
			return(
				<div>
					<Image src={this.state.url} style={{ height: '40vh', maxWidth: '100%', marginTop: 160 }} />
					<div className="row justify-content-center"> Plan Expirado.</div>
					<div className="row justify-content-center"> Contactarse a contacto@simpleqr.cl.</div>

				</div>
				
			)
		} else{
			if (this.state.loaded === false)
				return (
					<div
						className="row justify-content-center"
						style={{
							transform: `translate(${this.state.currentPosition}%, 20px)`,
							opacity: this.state.opacity,
							transition: 'all 2s ease-in'
						}}
					>
						<Image src={Logo} style={{ height: '40vh', maxWidth: '60%', marginTop: 160 }} />{' '}
					</div>
				);
			
			return <Redirect to={{ pathname: `/${this.state.nameStore}/products` }} />;
		}

		
		
	}
}

const mapDispatchToProps = (dispatch) => ({
	addShopInfo(shopUid) {
		dispatch(addShopInfoAction(shopUid));
	},

	addCategoriesProducts(data) {
		dispatch(addCategoriesProductsAction(data));
	}
});

export default connect(null, mapDispatchToProps)(Home);
